import { VERSION_1 } from 'libs/constants/b2bApiEndpoints'
import environment from 'environments/environment.dev'

import HttpClient from '../apiHttpClient'

const FAPI_TECHNICAL_ENDPOINT = `/${VERSION_1}/technicaluser`

const apiClient = new HttpClient(environment.shopFAPIUrl)

export const technicalUserService = {
  logHookURLForOCIUser: (url) => {
    return apiClient.post(`${FAPI_TECHNICAL_ENDPOINT}/debugurl`, {
      body: {},
      queryParams: { url },
    })
  },
}
